var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrash = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 9h11a.5.5 0 0 1 .5.5v11.25A1.25 1.25 0 0 1 16.75 22h-9.5A1.25 1.25 0 0 1 6 20.75V9.5a.5.5 0 0 1 .5-.5Zm12-5H14V2.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V4H5.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5Z"
})));
export default SvgTrash;